export default __webpack_public_path__ + "media/images/user/notification-9e8613d73462ce9a835e89e45dd93412.png";